export const currencyList = [
  { label: "United Arab Emirates Dirham", value: "AED", symbol: "د.إ" },
  { label: "Afghan Afghani", value: "AFN", symbol: "؋" },
  { label: "Albanian Lek", value: "ALL", symbol: "L" },
  { label: "Armenian Dram", value: "AMD", symbol: "֏" },
  { label: "Netherlands Antillean Guilder", value: "ANG", symbol: "ƒ" },
  { label: "Angolan Kwanza", value: "AOA", symbol: "Kz" },
  { label: "Argentine Peso", value: "ARS", symbol: "$" },
  { label: "Australian Dollar", value: "AUD", symbol: "$" },
  { label: "Aruban Florin", value: "AWG", symbol: "ƒ" },
  { label: "Azerbaijani Manat", value: "AZN", symbol: "₼" },
  { label: "Bosnia-Herzegovina Convertible Mark", value: "BAM", symbol: "KM" },
  { label: "Barbadian Dollar", value: "BBD", symbol: "$" },
  { label: "Bangladeshi Taka", value: "BDT", symbol: "৳" },
  { label: "Bulgarian Lev", value: "BGN", symbol: "лв" },
  { label: "Bahraini Dinar", value: "BHD", symbol: ".د.ب" },
  { label: "Burundian Franc", value: "BIF", symbol: "FBu" },
  { label: "Bermudian Dollar", value: "BMD", symbol: "$" },
  { label: "Brunei Dollar", value: "BND", symbol: "$" },
  { label: "Bolivian Boliviano", value: "BOB", symbol: "Bs." },
  { label: "Brazilian Real", value: "BRL", symbol: "R$" },
  { label: "Bahamian Dollar", value: "BSD", symbol: "$" },
  { label: "Bhutanese Ngultrum", value: "BTN", symbol: "Nu." },
  { label: "Botswana Pula", value: "BWP", symbol: "P" },
  { label: "Belarusian Ruble", value: "BYN", symbol: "Br" },
  { label: "Belize Dollar", value: "BZD", symbol: "$" },
  { label: "Canadian Dollar", value: "CAD", symbol: "$" },
  { label: "Congolese Franc", value: "CDF", symbol: "FC" },
  { label: "Swiss Franc", value: "CHF", symbol: "Fr" },
  { label: "Chilean Peso", value: "CLP", symbol: "$" },
  { label: "Chinese Yuan", value: "CNY", symbol: "¥" },
  { label: "Colombian Peso", value: "COP", symbol: "$" },
  { label: "Costa Rican Colón", value: "CRC", symbol: "₡" },
  { label: "Cuban Peso", value: "CUP", symbol: "$" },
  { label: "Cape Verdean Escudo", value: "CVE", symbol: "$" },
  { label: "Czech Koruna", value: "CZK", symbol: "Kč" },
  { label: "Djiboutian Franc", value: "DJF", symbol: "Fdj" },
  { label: "Danish Krone", value: "DKK", symbol: "kr" },
  { label: "Dominican Peso", value: "DOP", symbol: "RD$" },
  { label: "Algerian Dinar", value: "DZD", symbol: "دج" },
  { label: "Egyptian Pound", value: "EGP", symbol: "£" },
  { label: "Eritrean Nakfa", value: "ERN", symbol: "Nfk" },
  { label: "Ethiopian Birr", value: "ETB", symbol: "Br" },
  { label: "Euro", value: "EUR", symbol: "€" },
  { label: "Fijian Dollar", value: "FJD", symbol: "$" },
  { label: "Falkland Islands Pound", value: "FKP", symbol: "£" },
  { label: "Faroese Króna", value: "FOK", symbol: "kr" },
  { label: "Pound Sterling", value: "GBP", symbol: "£" },
  { label: "Georgian Lari", value: "GEL", symbol: "₾" },
  { label: "Guernsey Pound", value: "GGP", symbol: "£" },
  { label: "Ghanaian Cedi", value: "GHS", symbol: "₵" },
  { label: "Gibraltar Pound", value: "GIP", symbol: "£" },
  { label: "Gambian Dalasi", value: "GMD", symbol: "D" },
  { label: "Guinean Franc", value: "GNF", symbol: "FG" },
  { label: "Guatemalan Quetzal", value: "GTQ", symbol: "Q" },
  { label: "Guyanese Dollar", value: "GYD", symbol: "$" },
  { label: "Hong Kong Dollar", value: "HKD", symbol: "$" },
  { label: "Honduran Lempira", value: "HNL", symbol: "L" },
  { label: "Croatian Kuna", value: "HRK", symbol: "kn" },
  { label: "Haitian Gourde", value: "HTG", symbol: "G" },
  { label: "Hungarian Forint", value: "HUF", symbol: "Ft" },
  { label: "Indonesian Rupiah", value: "IDR", symbol: "Rp" },
  { label: "Israeli New Shekel", value: "ILS", symbol: "₪" },
  { label: "Isle of Man Pound", value: "IMP", symbol: "£" },
  { label: "Indian Rupee", value: "INR", symbol: "₹" },
  { label: "Iraqi Dinar", value: "IQD", symbol: "ع.د" },
  { label: "Iranian Rial", value: "IRR", symbol: "﷼" },
  { label: "Icelandic Króna", value: "ISK", symbol: "kr" },
  { label: "Jamaican Dollar", value: "JMD", symbol: "J$" },
  { label: "Jordanian Dinar", value: "JOD", symbol: "د.ا" },
  { label: "Japanese Yen", value: "JPY", symbol: "¥" },
  { label: "Kenyan Shilling", value: "KES", symbol: "KSh" },
  { label: "Kyrgyzstani Som", value: "KGS", symbol: "с" },
  { label: "Cambodian Riel", value: "KHR", symbol: "៛" },
  { label: "Kiribati Dollar", value: "KID", symbol: "$" },
  { label: "Comorian Franc", value: "KMF", symbol: "CF" },
  { label: "South Korean Won", value: "KRW", symbol: "₩" },
  { label: "Kuwaiti Dinar", value: "KWD", symbol: "د.ك" },
  { label: "Cayman Islands Dollar", value: "KYD", symbol: "$" },
  { label: "Kazakhstani Tenge", value: "KZT", symbol: "₸" },
  { label: "Lao Kip", value: "LAK", symbol: "₭" },
  { label: "Lebanese Pound", value: "LBP", symbol: "ل.ل" },
  { label: "Sri Lankan Rupee", value: "LKR", symbol: "Rs" },
  { label: "Liberian Dollar", value: "LRD", symbol: "$" },
  { label: "Lesotho Loti", value: "LSL", symbol: "L" },
  { label: "Libyan Dinar", value: "LYD", symbol: "ل.د" },
  { label: "Moroccan Dirham", value: "MAD", symbol: "د.م." },
  { label: "Moldovan Leu", value: "MDL", symbol: "L" },
  { label: "Malagasy Ariary", value: "MGA", symbol: "Ar" },
  { label: "Macedonian Denar", value: "MKD", symbol: "ден" },
  { label: "Myanmar Kyat", value: "MMK", symbol: "K" },
  { label: "Mongolian Tögrög", value: "MNT", symbol: "₮" },
  { label: "Macanese Pataca", value: "MOP", symbol: "P" },
  { label: "Mauritanian Ouguiya", value: "MRU", symbol: "UM" },
  { label: "Mauritian Rupee", value: "MUR", symbol: "₨" },
  { label: "Maldivian Rufiyaa", value: "MVR", symbol: "Rf" },
  { label: "Malawian Kwacha", value: "MWK", symbol: "MK" },
  { label: "Mexican Peso", value: "MXN", symbol: "$" },
  { label: "Malaysian Ringgit", value: "MYR", symbol: "RM" },
  { label: "Mozambican Metical", value: "MZN", symbol: "MT" },
  { label: "Namibian Dollar", value: "NAD", symbol: "$" },
  { label: "Nigerian Naira", value: "NGN", symbol: "₦" },
  { label: "Nicaraguan Córdoba", value: "NIO", symbol: "C$" },
  { label: "Norwegian Krone", value: "NOK", symbol: "kr" },
  { label: "Nepalese Rupee", value: "NPR", symbol: "₨" },
  { label: "New Zealand Dollar", value: "NZD", symbol: "$" },
  { label: "Omani Rial", value: "OMR", symbol: "ر.ع." },
  { label: "Panamanian Balboa", value: "PAB", symbol: "B/." },
  { label: "Peruvian Sol", value: "PEN", symbol: "S/." },
  { label: "Papua New Guinean Kina", value: "PGK", symbol: "K" },
  { label: "Philippine Peso", value: "PHP", symbol: "₱" },
  { label: "Pakistani Rupee", value: "PKR", symbol: "₨" },
  { label: "Polish Złoty", value: "PLN", symbol: "zł" },
  { label: "Paraguayan Guaraní", value: "PYG", symbol: "₲" },
  { label: "Qatari Riyal", value: "QAR", symbol: "ر.ق" },
  { label: "Romanian Leu", value: "RON", symbol: "lei" },
  { label: "Serbian Dinar", value: "RSD", symbol: "дин" },
  { label: "Russian Ruble", value: "RUB", symbol: "₽" },
  { label: "Rwandan Franc", value: "RWF", symbol: "FRw" },
  { label: "Saudi Riyal", value: "SAR", symbol: "ر.س" },
  { label: "Solomon Islands Dollar", value: "SBD", symbol: "$" },
  { label: "Seychellois Rupee", value: "SCR", symbol: "₨" },
  { label: "Sudanese Pound", value: "SDG", symbol: "ج.س." },
  { label: "Swedish Krona", value: "SEK", symbol: "kr" },
  { label: "Singapore Dollar", value: "SGD", symbol: "$" },
  { label: "Saint Helena Pound", value: "SHP", symbol: "£" },
  { label: "Sierra Leonean Leone", value: "SLE", symbol: "Le" },
  { label: "Somali Shilling", value: "SOS", symbol: "Sh" },
  { label: "Surinamese Dollar", value: "SRD", symbol: "$" },
  { label: "South Sudanese Pound", value: "SSP", symbol: "£" },
  { label: "São Tomé and Príncipe Dobra", value: "STN", symbol: "Db" },
  { label: "Syrian Pound", value: "SYP", symbol: "£" },
  { label: "Swazi Lilangeni", value: "SZL", symbol: "E" },
  { label: "Thai Baht", value: "THB", symbol: "฿" },
  { label: "Tajikistani Somoni", value: "TJS", symbol: "ЅM" },
  { label: "Turkmenistan Manat", value: "TMT", symbol: "m" },
  { label: "Tunisian Dinar", value: "TND", symbol: "د.ت" },
  { label: "Tongan Paʻanga", value: "TOP", symbol: "T$" },
  { label: "Turkish Lira", value: "TRY", symbol: "₺" },
  { label: "Trinidad and Tobago Dollar", value: "TTD", symbol: "TT$" },
  { label: "Tuvaluan Dollar", value: "TVD", symbol: "$" },
  { label: "New Taiwan Dollar", value: "TWD", symbol: "NT$" },
  { label: "Tanzanian Shilling", value: "TZS", symbol: "Sh" },
  { label: "Ukrainian Hryvnia", value: "UAH", symbol: "₴" },
  { label: "Ugandan Shilling", value: "UGX", symbol: "USh" },
  { label: "United States Dollar", value: "USD", symbol: "$" },
  { label: "Uruguayan Peso", value: "UYU", symbol: "$U" },
  { label: "Uzbekistani Soʻm", value: "UZS", symbol: "so'm" },
  { label: "Venezuelan Bolívar", value: "VES", symbol: "Bs." },
  { label: "Vietnamese Đồng", value: "VND", symbol: "₫" },
  { label: "Vanuatu Vatu", value: "VUV", symbol: "Vt" },
  { label: "Samoan Tālā", value: "WST", symbol: "T" },
  { label: "Central African CFA Franc", value: "XAF", symbol: "Fr" },
  { label: "East Caribbean Dollar", value: "XCD", symbol: "$" },
  { label: "Special Drawing Rights", value: "XDR", symbol: "SDR" },
  { label: "West African CFA franc", value: "XOF", symbol: "Fr" },
  { label: "CFP Franc", value: "XPF", symbol: "₣" },
  { label: "Yemeni Rial", value: "YER", symbol: "﷼" },
  { label: "South African Rand", value: "ZAR", symbol: "R" },
  { label: "Zambian Kwacha", value: "ZMW", symbol: "ZK" },
  { label: "Zimbabwean Dollar", value: "ZWL", symbol: "$" },
];
